/**
 * Chrome-less Live Sheet window.
 *
 * Opened via window.open from the admin sheet (or bookmarked directly): no
 * sidebar, no dashboard header, no event title block — just the toolbar, the
 * stats bar and the grid, so a director can tile one window per event.
 * Edits save through the same path as the embedded grid, and the grid's
 * realtime subscription keeps this window and the main one in step.
 */
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import EventSheetTabs from "@/components/events/EventSheetTabs";
import { supabase } from "@/integrations/supabase/client";

export default function EventSheetWindowPage() {
  const { eventId } = useParams<{ eventId: string }>();
  const [eventName, setEventName] = useState<string>("");

  useEffect(() => {
    if (!eventId) return;
    let cancelled = false;
    (async () => {
      const { data } = await (supabase as any)
        .from("events")
        .select("name")
        .eq("id", eventId)
        .maybeSingle();
      if (cancelled) return;
      setEventName(data?.name ?? "");
    })();
    return () => {
      cancelled = true;
    };
  }, [eventId]);

  // The window title is how a director tells several open sheets apart.
  useEffect(() => {
    const previous = document.title;
    document.title = eventName ? `${eventName} — Live Sheet` : "Live Sheet";
    return () => {
      document.title = previous;
    };
  }, [eventName]);

  if (!eventId) return null;

  return (
    <div className="flex h-screen w-screen flex-col gap-3 bg-background p-3">
      <EventSheetTabs eventId={eventId} eventName={eventName} popout />
    </div>
  );
}
